module.exports = __webpack_public_path__ + "static/media/logoSP.a0b5e2c3.png";